/**
 * Created by jacmai on 3/27/2017.
 */
define(["marionette", "./template/apiResponseTemplate.html"], function (
  Marionette,
  ApiResponseTemplate,
) {
  var ApiResponseView = {};

  ApiResponseView.apiResponseLayout = Marionette.Layout.extend({
    template: ApiResponseTemplate,
    regions: {
      selector: "#apiResponseSelector",
    },
  });

  return ApiResponseView;
});
